import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Core/Context/AuthContext';
import { callApi } from '../../../Utils/Api/Api';
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  TOKEN_EXP,
  USER_DATA,
} from '../../../constants/applicationConstants';
import { Card, CardBody, CardTitle } from '@progress/kendo-react-layout';
import { Loader } from '@progress/kendo-react-indicators';
import './RedirectCard.scss';

const SocialLoginRedirect = () => {
  const navigate = useNavigate();
  const { updateUser, checkTokens } = useAuth();
  const [message, setMessage] = useState('Redirecting...');
  const [authenticating, setAuthenticating] = useState(true);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);

    // Check if auth code and driver are present in query params
    const authCode = query.get('code');
    const driver = query.get('state');

    if (authCode && driver) {
      verifyAuthCode(authCode, driver);
    } else if (checkTokens()) {
      window.location.replace('/');
    } else {
      navigate('/login');
    }
  }, [navigate, checkTokens]);

  const verifyAuthCode = async (code, driver) => {
    try {
      const payload = { code, driver };
      if (driver === 'openid') {
        const verifier = sessionStorage.getItem('OIDC_CODE_VERIFIER');
        if (verifier) {
          payload.code_verifier = verifier;
        }
      }
      const response = await callApi('/social/auth/Code', 'POST', payload);
      if (response?.isSuccess) {
        const data = response.payload;
        sessionStorage.setItem(ACCESS_TOKEN, data.token.access_token);
        sessionStorage.setItem(REFRESH_TOKEN, data.token.refresh_token);
        sessionStorage.setItem(TOKEN_EXP, data.token.expires_in);
        sessionStorage.setItem(USER_DATA, JSON.stringify(data));
        if (driver === 'openid') {
          sessionStorage.removeItem('OIDC_CODE_VERIFIER');
        }
        updateUser(data);
        window.location.replace('/');
      } else {
        handleAuthenticationError('Failed to authenticate.');
      }
    } catch (error) {
      handleAuthenticationError('Authentication failed. Please try again.');
    }
  };

  const handleAuthenticationError = (errorMessage) => {
    setAuthenticating(false); // Stop showing "Please wait" message
    // setMessage(errorMessage); // Update the message state with the error
    setTimeout(() => navigate('/login'), 3000); // Redirect to login after 5 seconds
  };
  return (
    <div className="auth-container">
      <Card className="auth-card">
        <div className="auth-header">
          <CardTitle>Authentication Status</CardTitle>
        </div>
        <CardBody className="auth-body">
          <div className="auth-message">{message}</div>

          {authenticating ? (
            <>
              <div className="auth-submessage">
                Please wait while we complete your authentication.
              </div>
              <div className="loader-container">
                <Loader size="medium" type="pulsing" themeColor="info" />
              </div>
            </>
          ) : (
            <div className="auth-submessage">Redirecting...</div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default SocialLoginRedirect;
